<div class="page event">
  <div class="container">
    <div class="page__header flex-align-center flex flex-justify-between">
      <div>
        <h1 class="title title--bold" *ngIf="!editMode">{{ 'EVENT.new_event' | translate }}</h1>
        <h1 class="title title--bold" *ngIf="editMode">{{ 'EVENT.edit_event' | translate }}</h1>
      </div>
      <div class="event-control">
        <button
          class="btn btn--outline btn--md btn--primary"
          (click)="createEvent(1)"
          *ngIf="!(event && event.status === 2)"
        >
          {{ 'EVENT.save_to_drafts' | translate }}
        </button>
        <!-- if email is activated -->
        <button
          class="btn btn--primary btn--md"
          [disabled]="disabled"
          *ngIf="+storage.user.is_active === 1"
          (click)="createEvent()"
        >
          {{ 'EVENT.publish' | translate }}
        </button>
        <!-- if email is not activated and user is normal-->
        <button
          class="btn btn--primary btn--md"
          [disabled]="disabled"
          *ngIf="+storage.user.is_active === 2 && storage.user.type === 'normal'"
          (click)="createEvent()"
        >
          {{ 'EVENT.publish' | translate }}
        </button>
        <!-- if email is not activated and user is legal-->
        <button
          class="btn btn--primary btn--md"
          [disabled]="disabled"
          *ngIf="+storage.user.is_active === 2 && storage.user.type === 'legal'"
          (click)="createEvent(1)"
        >
          {{ 'EVENT.publish' | translate }}
        </button>
      </div>
    </div>
    <div class="page__content">
      <app-ph-collapse
        [open]="true"
        class="event-new__sidebar isEvent card card--white card--shadow"
      >
        <app-ph-input
          [placeholder]="'EVENT.type' | translate"
          [validation]="'required'"
          type="select"
          bindValue="value"
          name="type"
          [showRequired]="true"
          [selectArray]="types"
          bindLabel="name"
          [correctForm]="form"
        ></app-ph-input>
        <app-ph-input
          [placeholder]="'EVENT.name' | translate"
          [validation]="'required'"
          type="text"
          name="name"
          [correctForm]="form"
          [showRequired]="true"
        ></app-ph-input>
        <p [innerHTML]="'EVENT.preview_image' | translate"></p>
        <div *ngIf="pickedTheme">
          <app-photo-theme-preview
            [currentUpload]="getPickedThemeImage()"
            (emitRemoveFile)="removeTheme($event)"
          ></app-photo-theme-preview>
        </div>
        <app-ph-upload
          styletype="primary"
          class="upload-img-sidebar"
          [correctForm]="formImg"
          [formDataFile]="true"
          [checkTags]="false"
          [requiredTags]="false"
          [ngClass]="{ hide: pickedTheme }"
          (phUploadSuccess)="addToCropper($event)"
          #previewImg
          name="previewImg"
        ></app-ph-upload>
        <p class="event__theme">
          {{ 'EVENT.pick_theme' | translate }}
          <span class="event__theme-picked" *ngIf="pickedTheme">{{ pickedTheme.name }}</span>
        </p>
        <app-ph-swiper [config]="themesSliderConfig" [arrowsType]="'events'" class="event__swipper">
          <div *ngFor="let item of themes; index as i" (click)="setCurrentTheme(i)">
            <img
              [ngClass]="item.selected ? 'picked' : null"
              [src]="Config.HOST + '/' + item.image"
              alt="{{ item.name }}"
            />
          </div>
        </app-ph-swiper>

        <app-ph-input
          type="googleAutocomplete"
          name="googleMapsInput"
          [placeholder]="'EVENT.location_or_address' | translate"
          [validation]="'required'"
          [showRequired]="true"
          [googleAutocompleteDefaultValue]="autocompleteEdit"
          [initValue]="autocompleteEdit"
          (setAddress)="setAddress($event)"
          [correctForm]="form"
          [formControl]="form.get('googleMapsInput')"
        ></app-ph-input>
        <div class="project__map">
          <div class="project__map-title">{{ 'EVENT.show_us_where_it_will_be' | translate }}</div>
          <app-open-street-map-with-marker
            #openStreetMap
            [updatePositionOnMapClick]="changeMapOnClick"
            [markerDraggable]="markerDraggable"
            [form]="form"
            formControlPrefix="address"
          ></app-open-street-map-with-marker>
        </div>
      </app-ph-collapse>
      <div class="event-new__main card card--white card--shadow">
        <div class="event-new__main__row">
          <span>{{ 'EVENT.date_time' | translate }}</span>
          <div class="event-new__main__row--date--wrapper">
            <div class="event-new__main__row--date">
              <app-ph-input
                [placeholder]="'EVENT.start' | translate"
                [validation]="'required'"
                [initValue]=""
                type="datepicker"
                [datepickerReadOnly]="false"
                [searchable]="false"
                [disableDatepickerIcon]="true"
                [extraOptions]="datePickerExtraConfig"
                name="startAt"
                (valueChanged)="setStartDate()"
                [correctForm]="form"
              ></app-ph-input>
              <app-ph-input
                [validation]="'required'"
                type="select"
                name="startTime"
                [showRequired]="true"
                [selectArray]="times"
                (valueChanged)="startTimeChanged()"
                [correctForm]="form"
              ></app-ph-input>
            </div>
            <div *ngIf="!isEndDate" class="event-new__main__row--date">
              <button (click)="enableEndDate()" class="end_date__button">
                + {{ 'EVENT.end_date' | translate }}
              </button>
            </div>
            <div *ngIf="isEndDate" class="event-new__main__row--date">
              <app-ph-input
                [placeholder]="'EVENT.end' | translate"
                [validation]="'required'"
                [initValue]=""
                type="datepicker"
                [datepickerReadOnly]="false"
                [searchable]="false"
                [disableDatepickerIcon]="true"
                [extraOptions]="datePickerExtraConfigEndAt"
                name="endAt"
                (valueChanged)="endDateChanged()"
                [correctForm]="form"
              ></app-ph-input>
              <app-ph-input
                [validation]="'required'"
                type="select"
                name="endTime"
                [showRequired]="true"
                [selectArray]="endTimes"
                [correctForm]="form"
              ></app-ph-input>
            </div>
          </div>
        </div>
        <div class="event-new__main__row">
          <span>{{ 'EVENT.event_description' | translate }}</span>
          <app-ph-input
            [placeholder]="'EVENT.description_field' | translate"
            [validation]="'description_event'"
            type="textarea"
            name="description"
            [showRequired]="true"
            styletype="event"
            [correctForm]="form"
          ></app-ph-input>
        </div>
        <div class="event-new__main__row">
          <span>{{ 'EVENT.category' | translate }}</span>
          <div class="event-new__main__row__categories">
            <app-ph-input
              [placeholder]="'EVENT.pick_category' | translate"
              [validation]="'required'"
              type="select"
              [maxSelectedItems]="3"
              bindValue="id"
              [selectMultiple]="true"
              name="categories"
              [showRequired]="true"
              [selectArray]="categoriesFiltered"
              bindLabel="name"
              [initValue]="isWcd ? [28] : null"
              [correctForm]="form"
            ></app-ph-input>
            <span *ngIf="pickedTheme && pickedTheme.categories">
              {{ 'EVENT.picked_theme_category' | translate }}:
              <b>{{
                pickedTheme.categories.name
                  ? pickedTheme.categories.name
                  : pickedTheme.categories.data.name
              }}</b>
            </span>
          </div>
        </div>
        <div class="event-new__main__row">
          <span>{{ 'EVENT.invite_friends' | translate }}</span>
          <tag-input
            [(ngModel)]="emails"
            [placeholder]="'EVENT.add_next_invite' | translate"
            [modelAsStrings]="true"
            theme="minimal"
            [secondaryPlaceholder]="'EVENT.add_invite' | translate"
            [separatorKeyCodes]="[188]"
            [validators]="emailFieldValidators"
            [errorMessages]="errorMessagesCheckEmail"
            [addOnPaste]="true"
          ></tag-input>
        </div>
        <div class="event-new__main__row">
          <span></span>
          <app-ph-input
            [validation]="'checkbox'"
            name="checkBeneficent"
            type="checkbox"
            [ngClass]="{ disabled: loading }"
            [initValue]="isBeneficent"
            [correctForm]="formBeneficent"
            (mouseup)="setBeneficent(!formBeneficent.get('checkBeneficent').value)"
          >
            {{ 'EVENT.set_beneficent' | translate }}
          </app-ph-input>
        </div>
        <div class="event-new__main__row" *ngIf="isBeneficent">
          <span>{{ 'EVENT.event_organisation_help' | translate }}</span>
          <app-ph-input
            [placeholder]="'EVENT.pick_organisation' | translate"
            [validation]="'required'"
            type="select"
            bindValue="id"
            name="organization"
            [showRequired]="true"
            [selectArray]="organisations"
            bindLabel="name"
            [correctForm]="form"
          ></app-ph-input>
        </div>
      </div>
    </div>
  </div>
  <app-additional-info
    #additionalInfo
    (additionalClose)="unlockButton()"
    (additionalSuccess)="createEvent()"
  ></app-additional-info>
  <app-ph-cropper
    #phCropper
    [configCropper]="configCropper"
    (phCropperChange)="findCorrectPhUpload($event)"
  ></app-ph-cropper>
</div>
